'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _header = require('./../../header');

var _header2 = _interopRequireDefault(_header);

var _LogoOnlyHeaderDefaultProps = require('./LogoOnlyHeaderDefaultProps');

var _LogoOnlyHeaderDefaultProps2 = _interopRequireDefault(_LogoOnlyHeaderDefaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoOnlyHeader = function LogoOnlyHeader(props) {
  return _react2.default.createElement(_header2.default, props);
};

LogoOnlyHeader.defaultProps = _LogoOnlyHeaderDefaultProps2.default;
exports.default = LogoOnlyHeader;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/logo-only-header/jsx/LogoOnlyHeader.js
// module id = 1115
// module chunks = 4